import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { Separator } from 'office-ui-fabric-react/lib/Separator';
import DocumentTitle from 'react-document-title';
import Auth from "../../Auth/Auth";
import SubscriptionService, { SubscriptionType } from '../../services/SubscriptionService';
import PaymentService from '../../services/PaymentService';
import InespayService, { InespayType } from '../../services/InespayService';
import './Payments.sass';
import { useConst } from '@fluentui/react-hooks';
import React from 'react';

const stackTokens = { childrenGap: 20 };

const Payment = () =>
{
    const [error, setError] = useState({ status: false, message: '' });
    const [subscription, setSubscription] = useState<Partial<SubscriptionType>>({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const user = Auth.getUserProfile();
    const search = useLocation().search;
    const subscriptionId = new URLSearchParams(search).get('subscriptionId') || "";
    const usersSubscriptionId = new URLSearchParams(search).get('usersSubscriptionId') || "";
    const initialContribution = (new URLSearchParams(search).get('initialContribution')) || "";
    const managedPortfolioId = (new URLSearchParams(search).get('managedPortfolioId')) || "";
    const bmePortfolioId = (new URLSearchParams(search).get('bmePortfolioId')) || "";
    const today = new Date();
    today.setDate(today.getDate() + 1);
    const reference = useConst(`${user.id}-S${subscriptionId}-${today.valueOf().toString()}`);

    useEffect(() =>
    {
        SubscriptionService.getSubscription(parseInt(subscriptionId)).then((data: SubscriptionType) =>
        {
            setSubscription(data);
        },
        (error) =>
        {
            setError(error);
        });
    }, [subscriptionId]);

    const sendPayment = (event: any) =>
    {
        event.preventDefault();
        setIsSubmitted(true);

        if(subscription?.price === undefined || subscription?.price === null)
        {
            setError({ status: true, message: "La suscripción elegida no tiene precio definido" });
            setIsSubmitted(false);
        }
        else
        {
            var price = subscription?.price;
            PaymentService.createPayment(
            {
                reference: reference,
                amount: price,
                subject: `${user.id}-${subscription.id}`,
                status: 1,
                usersSubscriptionId: parseInt(usersSubscriptionId),
                platform: "INESPAY"
            }).then(() =>
            {
                var inespayData: InespayType =
                {
                    subject: `${user.id}-${subscription.id}`,
                    reference: reference,
                    amount: (price * 100).toString(),
                    subscription: true,
                    usersSubscriptionId: parseInt(usersSubscriptionId)
                };

                if(initialContribution !== "")
                {
                    inespayData.initialContribution = parseFloat(initialContribution)
                }
                if(managedPortfolioId !== "")
                {
                    inespayData.managedPortfolioId = parseInt(managedPortfolioId)
                }
                if(bmePortfolioId !== "")
                {
                    inespayData.bmePortfolioId = parseInt(bmePortfolioId)
                }

                sendToInespay(inespayData);
            },
            (error: any) =>
            {
                setError(error);
            });
        }
    };

    const sendToInespay = (inespayData: InespayType) =>
    {
        InespayService.postInespay(inespayData).then((dataInespay: any) =>
        {
            const inespay_result = JSON.parse(dataInespay.Result);
            if(inespay_result.status === '200')
            {
                window.location.href = inespay_result.url;
            }
            else
            {
                setError(
                {
                    status: false,
                    message: inespay_result.description
                });
                setIsSubmitted(false);
            }
        },
        (error: any) =>
        {
            setError(error);
        });
    };

    if(error.status)
    {
        return(
            <DocumentTitle title='IronIA - Pago'>
                <div>Error: {error.message}</div>
            </DocumentTitle>
        );
    }

    return(
        <DocumentTitle title='IronIA - Pago'>
            <React.Fragment>
                <div className="ms-Grid-row tight">
                    <h2>Detalles de pago</h2>
                    <p className="description">Este método de pago conecta con su banca online utilizando las claves de acceso de su banca online: </p>
                    <Separator className="separator" />
                </div>
                <div className="ms-Grid-row tight">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg5">
                            <div className="blue payment-data">
                                <dl>
                                    <dt>Beneficiario</dt>
                                    <dd>
                                        <ul>
                                            <li>DIAPHANUM VALORES, SV, S.A.U | A87637450</li>
                                            <li>Maria de Molina 40, Planta 7 - Madrid 28006</li>
                                        </ul>
                                    </dd>
                                    <dt>Referencia</dt>
                                    <dd>Orden IronIA {reference}</dd>
                                    <dt>Nombre de la Suscripción</dt>
                                    <dd>{subscription.name}</dd>
                                    <dt>Importe</dt>
                                    <dd>{subscription.price} €</dd>
                                </dl>
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg7">
                            <div className="payment">
                                <form>
                                    <Stack tokens={stackTokens}>
                                        <Stack.Item grow>
                                            <i className="ironia-icon calendar" /> Pago puntual
                                        </Stack.Item>
                                        <Stack.Item grow>
                                            Realiza un pago cada vez que caduque tu suscripción y utiliza nuestro programa de lealtad,
                                            Elements, para obtener promociones.
                                        </Stack.Item>
                                        <Stack.Item grow className="text-right">
                                            <button className="button primary-button"
                                                onClick={(event: any) => sendPayment(event)}
                                                disabled={isSubmitted}
                                            >
                                                {isSubmitted && (<Spinner size={SpinnerSize.small} className="button-spinner" />)}
                                                Pagar
                                            </button>
                                        </Stack.Item>
                                    </Stack>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        </DocumentTitle>
    );
};

export default Payment;